module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-3"
  }, [(_vm.paymentMethods) ? _c('ul', _vm._l((_vm.reservation.billing.refunds), function(refund, index) {
    return _c('li', {
      staticClass: "d-flex mb-3"
    }, [_c('div', {
      staticClass: "d-flex"
    }, [_c('div', {
      staticClass: "flex-all mr-3"
    }, [_c('label', [_vm._v("Payment Method")]), _vm._v(" "), _c('vSelect', {
      attrs: {
        "options": _vm.paymentMethods,
        "placeholder": "- Select type -",
        "label": "description"
      },
      model: {
        value: (refund.type),
        callback: function($$v) {
          _vm.$set(refund, "type", $$v)
        },
        expression: "refund.type"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "flex-all"
    }, [_c('label', [_vm._v("Amount")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (refund.value),
        expression: "refund.value"
      }],
      staticClass: "mb-0 text-right",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (refund.value)
      },
      on: {
        "keyup": _vm.validateRefunds,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(refund, "value", $event.target.value)
        }
      }
    })]), _vm._v(" "), (index > 0) ? _c('div', {
      staticClass: "pointer mt-5 ml-4",
      on: {
        "click": function($event) {
          return _vm.deleteRow(index)
        }
      }
    }, [_c('i', {
      staticClass: "ico-delete largest"
    })]) : _c('div', {
      staticClass: "pointer color-1 ml-4 mt-5",
      on: {
        "click": function($event) {
          return _vm.addRow(refund.type)
        }
      }
    }, [_c('i', {
      staticClass: "ico-add add-circle"
    })])])])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.validTotal) ? _c('ul', [_vm._m(0)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "d-flex error align-items-center mb-4"
  }, [_c('i', {
    staticClass: "ico-alert largest"
  }), _vm._v("\n            The total refund doesn't match the total payment for this product.\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b96b8bd"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/CancellationMethods.vue
// module id = 1563
// module chunks = 0